var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('span',{class:_vm.$style.message},[_vm._v(" This user is private. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }